import React, { Component } from 'react';
import Toggle from 'material-ui/Toggle';
import { connect } from 'react-redux';
import { keycode } from 'utils/events';
import { mapStateToProps, mapDispatchToProps } from '../redux';
import colors from 'constants/colors';

@connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })
class RenderBool extends Component {
    focus = () => {
        this._autoComplete.refs.enhancedSwitch.refs.checkbox.focus();
    };

    onKeyDown = (event) => {
        const { onNavigationKeyPressed } = this.props;
        onNavigationKeyPressed && onNavigationKeyPressed(keycode(event));
    };

    render() {
        let { width, edit, value, config, onChange, onNavigationKeyPressed } = this.props;
        value = value ? value : false;
        const thumbStyle = value === 1 ? { 'background-color': colors.$fmOrange } : null;
        const trackStyle = value === 1 ? { 'background-color': colors.$fmOrangeLight } : null;
        return (
            <div style={{ width, display: 'inline-block' }}>
                <div className="toggle-fm" style={{ display: 'inline-block' }}>
                    <Toggle
                        {...this.props}
                        ref={(e) => (this._autoComplete = e)}
                        onKeyDown={this.onKeyDown}
                        style={{ display: 'inline-block' }}
                        thumbStyle={thumbStyle}
                        trackStyle={trackStyle}
                        defaultToggled={value}
                        onToggle={(_, value) => onChange(value)}
                        onNavigationKeyPressed={onNavigationKeyPressed}
                        disabled={!edit || config.readOnly}
                    />
                </div>
            </div>
        );
    }
}

export default RenderBool;
